
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'

import MixinInterface from '@/_mixins/index'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import { searchCompanies } from '@/views/Company/utils/company'
import { countries } from '@/types/countries'

@Component({
    inheritAttrs: false,
    mixins: [CompanyInfoMixin],
    components: { DialogTemplate },
})
export default class SearchCompanyByOrgNumDialog extends Mixins<MixinInterface>(CompanyInfoMixin) {
    $refs!: {
        form: Vue & { resetValidation: () => void; validate: () => void }
    }

    valid = false
    orgNum = ''
    items = [] as Array<any>
    errors = [] as Array<string>
    offset = 0
    limit = 20
    loading = false
    company = null as null | Record<string, any>
    nationality = null as null | Record<string, any>
    companySelected = false

    get nationalities() {
        return countries
    }

    get formatedOrgNum() {
        return this.orgNum ? this.orgNum.split(' ').join('').split('-').join('') : ''
    }

    get validOrgNum() {
        if (this.company) return true
        if (!this.nationality?.orgNumberReg) return true

        return this.company
            ? true
            : this.nationality
            ? !!this.formatedOrgNum.match(this.nationality.orgNumberReg)
            : false
    }

    nameWithOrgNum(val) {
        if (!val || !val.name) return ''
        const formatedOrgNumber = val.orgNo
            ? `(${val.nationality ? this.formatOrgNumber(val.orgNo, val.nationality) : val.orgNo})`
            : null
        return `${val.name} ${formatedOrgNumber ? formatedOrgNumber : ''}`
    }

    countryName(val) {
        const translationKey = `country['${val.code.toLowerCase()}']`
        let text = this.$te(translationKey) ? this.$t(translationKey) : val.name

        return text
    }

    validationHint() {
        if (!this.nationality) return null
        const translationKey = `company_fe['search_company_orgNum.orgNum_hint_${this.nationality.code}']`

        let text = this.$te(translationKey) ? this.$t(translationKey) : null

        return text
    }

    rulesOrgNum() {
        return [
            () =>
                !this.errors.includes('invalidOrgNoForNationality') ||
                this.$t(`company_errors['company.get.invalidOrgNoForNationality']`),
        ]
    }

    mounted() {
        this.nationality = this.nationalities[0]
    }

    // When user blurs without selecting company
    //autoselect it if it exists
    selectCompanyOnBlur() {
        if (this.items.length > 0) {
            this.companySelected = true
            this.company = this.items[0]
        }
    }

    @Watch('nationality')
    cleanCompanyOnNatChanged() {
        this.company = null
        this.items = []
    }

    @Debounce(500)
    async searchByOrgNum() {
        if (!this.nationality || !this.formatedOrgNum || this.formatedOrgNum.length < 2) return
        if (!this.validOrgNum) return

        this.loading = true

        try {
            this.items = await searchCompanies({
                'filter[orgNo]': this.formatedOrgNum,
                'filter[nationality]': this.nationality?.code,
            })
        } catch (error) {
            this.$store.commit('closeSnackbar')
            error.data.response.data.errors.map((err) => {
                this.errors.push(err.code)
                this.$refs?.form?.validate()
            })
        } finally {
            this.loading = false
        }
    }

    @Watch('orgNum')
    initiateSearch() {
        if (this.companySelected) return

        this.company = null
        this.items = []

        if (!this.nationality || !this.formatedOrgNum || this.formatedOrgNum.length < 2) return
        if (!this.validOrgNum) return
        this.loading = true
    }

    @Debounce(500)
    @Watch('orgNum')
    performSearch() {
        if (this.companySelected) {
            this.companySelected = false
            return
        }
        this.errors = []
        this.$refs?.form?.resetValidation()
        this.searchByOrgNum()
    }
}
